export interface ICreateOrganizationKeyInput {
    name: string;
    value: string;
    webhookTrigger: boolean;
    permissions: string[];
    routingMatrix: boolean;
}
